import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useChipMenuStyles = makeStyles()(theme => ({
  content: {
    padding: theme.spacing(2),
  },
  title: {
    alignItems: 'center',
    borderBottom: `1px solid ${grey[300]}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2, 3),
    '& svg': {
      height: '24px',
      fill: theme.palette.text.secondary,
      width: '24px',
    }
  }
}));
